import React, { useState } from 'react';
import FullBlockingModal from '../common/FullBlockingModal';
import { useTranslation } from 'react-i18next';
import { Quote } from '../../types/quote';
import RecruiterReview from './RecruiterReview';
import FreelancerReview from './FreelancerReview';
import { useProfileRole } from '../../hooks/useProfileRole';
import GenericInformationModal from '../common/GenericInformationModal';

interface ReviewModalProps {
  quote: Quote;
  onClose: () => void;
  onClick?: () => void;
}

const ReviewModal: React.FC<ReviewModalProps> = ({ onClose, quote, onClick }) => {
  const { t } = useTranslation(['common', 'reviews']);

  const [showRecruiterInformation, setShowRecruiterInformation] = useState(false);
  const [showFreelancerInformation, setShowFreelancerInformation] = useState(false);

  const { isRecruiter } = useProfileRole();

  const recruiterName = `${quote.job.client.first_name} ${quote.job.client.last_name}`;
  const freelancerName = `${quote.quote_owner.first_name} ${quote.quote_owner.last_name}`;

  const renderContent = () => {
    return isRecruiter ? (
      <RecruiterReview
        quote={quote}
        onComplete={() => {
          setShowRecruiterInformation(true);
          onClick?.();
        }}
        onClose={onClose}
      />
    ) : (
      <FreelancerReview
        quote={quote}
        onComplete={() => {
          setShowFreelancerInformation(true);
          onClick?.();
        }}
        onClose={onClose}
      />
    );
  };

  return (
    <>
      <FullBlockingModal innerClassName="md:max-w-[72rem]">
        <button
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl md:top-0"
          onClick={onClose}
          aria-label={t('common:form_actions.close', { ns: 'common', defaultValue: 'Fermer' })}
        >
          &times;
        </button>

        {renderContent()}
      </FullBlockingModal>

      {(showFreelancerInformation || showRecruiterInformation) && (
        <GenericInformationModal
          title={
            isRecruiter
              ? t('successfulRating', {
                  ns: 'reviews',
                  defaultValue: 'Votre évaluation de {{name}} a été bien enregistrée',
                  name: freelancerName || 'cet utilisateur',
                })
              : t('successfulRating', {
                  ns: 'reviews',
                  defaultValue: 'Votre évaluation de {{name}} a été bien enregistrée',
                  name: recruiterName || 'cet utilisateur',
                })
          }
          message=""
          onClose={() => {
            setShowFreelancerInformation(false);
            setShowRecruiterInformation(false);
            onClose();
          }}
          closeButtonLabel={t('common:form_actions.close', { ns: 'common' })}
        />
      )}
    </>
  );
};

export default ReviewModal;
